import { render, staticRenderFns } from "./OfferRow.vue?vue&type=template&id=b43aafac&scoped=true"
import script from "./OfferRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./OfferRow.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./OfferRow.vue?vue&type=style&index=0&id=b43aafac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b43aafac",
  null
  
)

export default component.exports